module.exports = __webpack_public_path__ + "static/media/standard_and_set_menu.0731430f.svg";